// Components
import styled from 'styled-components6';

export const Divider = styled.div`
    margin-top: var(--rwl-spacing-md);
    margin-bottom: var(--rwl-spacing-md);
    border-bottom: 1px solid var(--rwl-palette-gray-200);
`;

export * from './Typography';
export * from './Button';
export * from './ButtonGroup';

export * from './theme';
export * from './CSSVarThemeProvider';
export { findClosestColor } from './colors';
